import { pathGenerator } from '../utils/url';

const getFullLink = (protocol: string, deepLinks: Record<string, unknown>) => {
  const result: Record<string, string | ((id: string) => string)> = {};

  Object.entries(deepLinks).forEach(([key, value]) => {
    if (typeof value === 'function') {
      result[key] = (id: string) => `${protocol}${value(id)}`;
    } else {
      result[key] = `${protocol}${value}`;
    }
  });

  return result;
};

const deepLinks = {
  PAYMENT: pathGenerator('manage_credit_card'),
  MOCHI_COIN: pathGenerator('open_mochi_coin', {
    need_login: 'true',
  }),
  SUPPORT_GAS_STATIONS: pathGenerator('open_collection', {
    poi_collection: 'gas_station_all',
  }),
  SUPPORT_GAS_STATIONS_MOCHIPAY: pathGenerator('open_collection', {
    poi_collection: 'gas_station_mochipay',
  }),
  SUPPORT_GAS_STATIONS_PASS: pathGenerator('open_collection', {
    poi_collection: 'gas_station_pass',
  }),
  SUPPORT_GAS_STATIONS_BARCODE_PAYMENT: pathGenerator('open_collection', {
    poi_collection: 'barcode_payment_all',
  }),
  SUPPORT_PARKINGLOTS: pathGenerator('open_collection', {
    poi_collection: 'parkinglot_all',
  }),
  OPEN_GAS_STATION_CARD: (id: string) =>
    pathGenerator('open_gas_station_card', { id, expanded: 'true' }),
  OPEN_PARKINGLOT_CARD: (id: string) =>
    pathGenerator('open_parkinglot_card', { id, expanded: 'true' }),
};

export const devAppDeepLink = getFullLink('autopassapp-alpha://', deepLinks);

export const prodAppDeepLink = getFullLink('autopassapp://', deepLinks);
